module.exports = __webpack_public_path__ + "static/media/horizontal-distribution-right.d02d471f.svg";